import { createContext, useContext } from 'react';
/**
 * Provides the ability to toggle the auth sign in modal anywhere in the React tree
 */
export const AuthSignInFlyoutContext = createContext({
    toggleSignInModal: () => { },
    enabled: false,
});
/**
 * Convenience hook to use the AuthSignInFlyoutContext
 */
export const useAuthSignInFlyoutContext = () => useContext(AuthSignInFlyoutContext);
